/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgBoldBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.5 19.4987H13C14.1935 19.4987 15.3381 19.0246 16.182 18.1806C17.0259 17.3367 17.5 16.1921 17.5 14.9987C17.5 13.8052 17.0259 12.6606 16.182 11.8167C15.3381 10.9728 14.1935 10.4987 13 10.4987H13.5C13.894 10.4987 14.2841 10.4211 14.6481 10.2703C15.012 10.1195 15.3427 9.89855 15.6213 9.61998C15.8999 9.3414 16.1209 9.01068 16.2716 8.64671C16.4224 8.28273 16.5 7.89262 16.5 7.49866C16.5 7.10469 16.4224 6.71458 16.2716 6.35061C16.1209 5.98663 15.8999 5.65591 15.6213 5.37734C15.3427 5.09876 15.012 4.87778 14.6481 4.72702C14.2841 4.57625 13.894 4.49866 13.5 4.49866H6.5"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 4.49866V19.4987"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 10.4987H8.5"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgBold = wrapIcon(SvgBoldBase);
export default SvgBold;
